<script setup>
import { useRouter } from "vue-router";
import { useLoaderStore } from "@store/loader";

const router = useRouter();
const loader = useLoaderStore();
</script>

<template>
    <form-btn
        :label="$t('messages.cancel')"
        @click="router.back()"
        :disabled="loader.isLoading"
        class="btn btn-light"
    />
</template>
